import { render } from "./BaseRequestForm.vue?vue&type=template&id=3b935d9f"
import script from "./BaseRequestForm.vue?vue&type=script&lang=js"
export * from "./BaseRequestForm.vue?vue&type=script&lang=js"

import "./BaseRequestForm.vue?vue&type=style&index=0&id=3b935d9f&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__